import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { LoadResoursesService } from '../../../services/load-resourses/load-resourses.service';
import { AuthService } from '../../../services/http/auth/auth.service';
import { GameStateService } from '../../../services/game-state/game-state.service';
import { PaymentService } from '../../ui/modals/payment/payment.service';
import { switchMap, retry, timer } from 'rxjs';
import { AudioService } from '../../../services/audio/audio.service';
import { MetrikaService } from '../../../services/metrika.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent implements OnInit, OnDestroy {
  // @ViewChild('progress', { static: false }) progressBar: ElementRef<HTMLElement>;

  isLoading = true;
  showStartButton = false;

  welcomeTexts = [
    'Выбор профессии... Одно из самых важных решений в жизни. Но когда этот момент наступает, мы оказываемся не готовы. Нет ни опыта, ни знаний. Школа не рассказала, как живут люди за пределами учебных кабинетов. А родители? У них свой путь, но он может не подойти тебе.',
    '"Ты уже определился с профессией?" — спрашивают тебя. Но как выбрать, если перед тобой целый океан профессий, в котором ты еще не плавал...',
    'Что делать в такой ситуации?',
    'Конечно же, только...'
  ];

  @Output() initGame: EventEmitter<void> = new EventEmitter<void>();

  private _step = 1;
  progress = 0; // Начинаем с 0, а не с 10
  showProgressBar = false;
  
  public get step() {
    return this._step;
  }
  
  public set step(value) {
    this._step = value;
  }

  intervalId: any;
  tokenUpdated = false;

  constructor(
    private loadService: LoadResoursesService,
    private authService: AuthService,
    private state: GameStateService,
    private cdr: ChangeDetectorRef,
    private payment: PaymentService,
    private metrika: MetrikaService,
  ) {}

  ngOnInit(): void {
    const token = localStorage.getItem('refresh_token');
    if (!token) {
      this.payment.start().pipe(
        retry({
          count: 5,
          delay: (error, retryCount) => {
            console.warn(`Попытка ${retryCount} не удалась, повтор через ${retryCount * 1000}мс...`, error);
            return timer(retryCount * 1000);
          }
        })
      ).subscribe((data: any) => {
        if (data.hash) localStorage.setItem('hash', data.hash);
        this.tokenUpdated = true;
      });
      this.resetGameState();
      this.startLoadingIfReady();
    } else {
      this.authService.refreshToken(token).subscribe({
        error: () => {
          this.resetGameState();
          this.tokenUpdated = true;
          this.cdr.detectChanges();
          this.startLoadingIfReady();
        },
        next: () => {
          this.tokenUpdated = true;
          this.cdr.detectChanges();
          this.startLoadingIfReady();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  /**
   * Запускает загрузку, если токен обновлен
   */
  private startLoadingIfReady(): void {
    this.showProgressBar = true;
    this.loadInitialResources();
  }

  /**
   * Загружает начальные ресурсы через новый сервис
   */
  private async loadInitialResources(): Promise<void> {
    try {
      await this.loadService.loadInitialResources(this.onProgress.bind(this));

			if (this.state.getGameStatus('completedLocation') !== 0) {
        this.loadService.loadAdditionalResources()
          .then(() => {
            this.showStartButton = true;
            this.cdr.detectChanges();
            // console.log('Дополнительные ресурсы загружены');
          })
          .catch(error => {
            console.warn('Ошибка загрузки дополнительных ресурсов:', error);
            this.loadService.retryLoading().then(() => {
            this.cdr.detectChanges();
          }).catch(() =>   alert('Ошибка загрузки! Попробуйте перезагрузить страницу'));
        });
      }
    } catch (error) {
      console.error('Ошибка загрузки ресурсов:', error);
      this.loadService.retryLoading().then(() => {
        this.showStartButton = true;
        this.cdr.detectChanges();
      }).catch(() => alert('Ошибка загрузки! Попробуйте перезагрузить страницу'));
    }
  }

  onProgress(progress: number) {
    this.progress = Math.round(progress);
    
    // console.log('progress',progress);
    if (this.progress >= 100) {
      if (this.state.getGameStatus('completedLocation') == 0) this.showStartButton = true;
      this.cleanup();
    }
    this.cdr.detectChanges();
  }

  private resetGameState() {
    this.authService.logout();
    this.state.changeGameStatus('completedLocation', 0);
    const traps = this.state.getGameStatus('traps') ?? {};
    this.state.changeGameStatus('traps', {t0:traps['t0']});
    this.state.changeGameStatus('paymentType', 0);

    // TO FIX
    
    const currentLocation = localStorage.getItem('currentLocation');
    if (currentLocation && currentLocation !== '1') {
      localStorage.setItem('currentLocation', '1');
      this.state.changeGameStatus('savedPlayerPosition', undefined);
    }
  }

  nextStep(timeout?: boolean) {
    if (timeout) {
      setTimeout(() => {
        this.step++;
        this.cdr.detectChanges();
      }, 1000);
    } else {
      this.step++;
      this.cdr.detectChanges();
    }
  }

  play() {
    this.metrika.reachGoal('game_start');
    this.initGame.emit();
  }

  private cleanup(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
  }
}